import { render, staticRenderFns } from "./DashboardPub.vue?vue&type=template&id=3ca7792c&"
import script from "./DashboardPub.vue?vue&type=script&lang=js&"
export * from "./DashboardPub.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPub.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports